import { Box, Typography } from "@mui/material";
import { StyledTableCell } from "../style";

export default function Map({ hashmap, content, ...rest }) {
  const entry = hashmap?.[content];
  return (
    <StyledTableCell {...rest} align="center">
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
        {entry ? (
          entry?.value || entry?.color ? (
            <Typography variant="body2" color={entry?.color}>
              {entry?.value || entry}
            </Typography>
          ) : (
            entry
          )
        ) : (
          content
        )}
      </Box>
    </StyledTableCell>
  );
}
